import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FeatureInterface } from '../../interfaces/feature.interface';
import { ScrollAnimationDirective } from '../../directives/scroll-animation.directive';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-features',
  standalone: true,
  imports: [CommonModule, MatIconModule, ScrollAnimationDirective, TranslateModule],
  template: `
    <section id="support" class="section features-section">
      <div class="container">
        <h2 class="section-title text-center" scrollAnimation>{{ sectionTitle }}</h2>
        <p class="section-subtitle text-center" scrollAnimation>{{ sectionSubtitle }}</p>
        <div class="features-grid">
          <div class="feature-card" *ngFor="let feature of features" scrollAnimation>
            <div class="icon-wrapper">
              <mat-icon class="feature-icon">{{ feature.icon }}</mat-icon>
            </div>
            <h3>{{ feature.title }}</h3>
            <p>{{ feature.description }}</p>
          </div>
        </div>
      </div>
    </section>
  `,
  styles: [`
    .section-title {
      font-size: 2.5rem;
      margin-bottom: 1.5rem;
      font-weight: 700;
      text-align: center;
      color: #300458;
    }
    
    .section-subtitle {
      font-size: 1.2rem;
      margin-bottom: 3rem;
      text-align: center;
      color: #000;
    }
    
    .features-section {
      background: var(--white);
      padding: 5rem 2rem;
    }
    
    .features-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
      gap: 2rem;
      margin-top: 4rem;
    }
    
    .feature-card {
      background: white;
      padding: 2rem;
      border-radius: var(--border-radius);
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      text-align: center;
      transition: transform 0.3s ease;
    }
    
    .feature-card:hover {
      transform: translateY(-5px);
    }
    
    .icon-wrapper {
      width: 80px;
      height: 80px;
      background: #6a1b9a;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 1.5rem;
    }
    
    .feature-icon {
      font-size: 40px;
      width: 40px;
      height: 40px;
      color: white;
    }
    
    h3 {
      color: #6a1b9a;
      margin-bottom: 1rem;
      font-size: 1.5rem;
    }
    
    p {
      color: var(--light-text);
      line-height: 1.6;
    }
  `]
})
export class FeaturesComponent implements OnInit {
  sectionTitle: string = '';
  sectionSubtitle: string = '';
  features: FeatureInterface[] = [];

  constructor(public _translate: TranslateService) {}

  ngOnInit(): void {
    // Localize the section header texts
    this.sectionTitle = this._translate.instant('FEATURES.SECTION_TITLE');
    this.sectionSubtitle = this._translate.instant('FEATURES.SECTION_SUBTITLE');

    // Localize the features array
    this.features = [
      {
        icon: 'attach_money',
        title: this._translate.instant('FEATURES.AFFORDABLE.TITLE'),
        description: this._translate.instant('FEATURES.AFFORDABLE.DESCRIPTION')
      },
      {
        icon: 'verified',
        title: this._translate.instant('FEATURES.PROFESSIONAL.TITLE'),
        description: this._translate.instant('FEATURES.PROFESSIONAL.DESCRIPTION')
      },
      {
        icon: 'route',
        title: this._translate.instant('FEATURES.CUSTOM_ROADMAP.TITLE'),
        description: this._translate.instant('FEATURES.CUSTOM_ROADMAP.DESCRIPTION')
      }
    ];
  }
}
